module.exports = __webpack_public_path__ + "static/media/premierFare.pictogram.b3232761.svg";